import { addDataLayerEntry, addEventEntry } from '@printdeal/data-layer-manager';
import {
  dispatchDataLayerEventOnProductsClickGA4,
} from '../../helpers/dataLayerHelpers/HomepageDataLayerHelper';

const HOMEPAGE_RECENTPRODUCTS = 'homepage_recentproducts';
const HOMEPAGE_SCROLLCUE = 'homepage_scrollcue';

export const handleOnScrollCueClick = (targetName: string) => {
  // GA3
  addEventEntry({
    eventCategory: HOMEPAGE_SCROLLCUE,
    eventAction: 'click',
    eventLabel: targetName,
  });

  // GA4
  addDataLayerEntry(
    `${HOMEPAGE_SCROLLCUE}_click`,
    {
      section: targetName,
    },
  );
};

export const handleRecentViewedProductOnClick = (productName: string, position: number) => {
  const eventdata = { eventName: HOMEPAGE_RECENTPRODUCTS, position, productName };
  dispatchDataLayerEventOnProductsClickGA4(eventdata);
};
